import {
  CREATE_OR_EDIT_GAME_TYPES_PERMISSION,
  CREATE_OR_EDIT_PLAYERS_PERMISSION,
  CREATE_OR_EDIT_STAT_TYPES_PERMISSION,
  CREATE_OR_EDIT_TEAMS_PERMISSION,
  EDIT_GAME_MODES_PERMISSION
} from '@bo-constants/permissions';
import { createSelector } from '@reduxjs/toolkit';
import { selectUserRoles } from '@bo-services/authenticationSlice';

export const selectHasEditPlayers = createSelector([selectUserRoles], (roles) =>
  roles.some((role) =>
    role.permissions.some(
      (permission) => permission.name === CREATE_OR_EDIT_PLAYERS_PERMISSION
    )
  )
);

export const selectHasEditStatTypes = createSelector(
  [selectUserRoles],
  (roles) =>
    roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === CREATE_OR_EDIT_STAT_TYPES_PERMISSION
      )
    )
);

export const selectHasEditGameTypes = createSelector(
  [selectUserRoles],
  (roles) =>
    roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === CREATE_OR_EDIT_GAME_TYPES_PERMISSION
      )
    )
);

export const selectHasEditGameModes = createSelector(
  [selectUserRoles],
  (roles) =>
    roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === EDIT_GAME_MODES_PERMISSION
      )
    )
);

export const selectHasEditTeams = createSelector([selectUserRoles], (roles) =>
  roles.some((role) =>
    role.permissions.some(
      (permission) => permission.name === CREATE_OR_EDIT_TEAMS_PERMISSION
    )
  )
);
